import * as origin from "@shopify/theme-cart";

export default () => ({
	loading: false,
	loadingCheckout: false,
	note: null,
	updateVariantInCart(key, quantity, properties = null) {
		console.log("minicart.js: updateVariantInCart()");
		this.loading = true;
		Alpine.store("shopify").cartLoading = true;
		origin
			.updateItem(key, { quantity, properties })
			.then((res) => {
				this.loading = false;
				Alpine.store("shopify").setCart(res);
				Alpine.store("shopify").cartLoading = false;
				console.log("minicart.js: Variant Updated: ", res);
			})
			.catch((err) => {
				console.log("minicart.js: Error updating variant: ", err);
				this.loading = false;
				Alpine.store("shopify").reload();
				Alpine.store("shopify").cartLoading = false;
			});
	},
	removeVariantFromCart(key) {
		console.log("minicart.js: removeVariantFromCart()", key);
		this.loading = true;
		Alpine.store("shopify").cartLoading = true;
		origin
			.removeItem(key)
			.then((res) => {
				this.loading = false;
				Alpine.store("shopify").setCart(res);
				Alpine.store("shopify").cartLoading = false;
				console.log("minicart.js: Variant Removed: ", res);
			})
			.catch((err) => {
				console.log(
					"minicart.js: Error removing variant from cart: ",
					err
				);
				this.loading = false;
				Alpine.store("shopify").reload();
				Alpine.store("shopify").cartLoading = false;
			});
	},
	updateCartNote(checkout) {
		console.log("checkout: ", checkout);
		console.log("updating cart note: ", Alpine.store("shopify").cart.note);
		this.loading = true;
		Alpine.store("shopify").cartLoading = true;
		origin
			.updateNote(Alpine.store("shopify").cart.note)
			.then((state) => {
				console.log(
					"The customer has written the following note:",
					state.note
				);
			})
			.then((res) => {
				this.loading = false;
				Alpine.store("shopify").cartLoading = false;
				Alpine.store("shopify").reload();
				console.log("minicart.js: Note Updated: ", res);
				if (checkout) {
					window.location = '/checkout'
				}
			})
			.catch((err) => {
				console.log(
					"minicart.js: Error updating note from cart: ",
					err
				);
				this.loading = false;
				Alpine.store("shopify").reload();
				Alpine.store("shopify").cartLoading = false;
			});
	},
	clearNote() {
		console.log("clearing cart note: ", Alpine.store("shopify").cart.note);
		this.loading = true;
		Alpine.store("shopify").cartLoading = true;
		origin
			.clearNote(Alpine.store("shopify").cart.note)
			.then((state) => {
				console.log(
					"The customer has cleared the note:",
					state.note
				);
			})
			.then((res) => {
				this.loading = false;
				Alpine.store("shopify").cartLoading = false;
				Alpine.store("shopify").reload();
				console.log("minicart.js: Note cleared: ", res);
			})
			.catch((err) => {
				console.log(
					"minicart.js: Error clearing note from cart: ",
					err
				);
				this.loading = false;
				Alpine.store("shopify").reload();
				Alpine.store("shopify").cartLoading = false;
			});
	},
	init() {
		console.log("minicart.js: init()");
		if (Alpine.store("shopify").showCartOnLoad()) {
			Alpine.store("shopify").toggleCart();
		}
	},
});
